// login
const login = {
    path: '/login',
    name: 'Login',
    meta: {
        title: '登录'
    },
    component: resolve => {
        require(['@/views/login/login.vue'], resolve)
    }
}
const realAccount = {
    path: '/realAccount',
    name: 'realAccount',
    meta: {
        title: '开立真实账户'
    },
    component: resolve => {
        require(['@/views/account/real-account.vue'], resolve);
    }
}
const demoAccount = {
    path: '/demoAccount',
    name: 'demoAccount',
    meta: {
        title: '开立模拟账户'
    },
    component: resolve => {
        require(['@/views/account/demo-account.vue'], resolve);
    }
}
const agreement = {
    path: '/agreement',
    name: 'agreement',
    meta: {
        title: '客户协议'
    },
    component: resolve => {
        require(['@/views/account/agreement.vue'], resolve);
    },
}

// 忘记密码
const forgetPwd = {
    path: '/forget_pwd',
    name: 'forgetPwd',
    meta: {
        title: '忘记密码'
    },
    component: resolve => {
        require(['@/views/login/forget-pwd.vue'], resolve)
    }
}

// 403
const page403 = {
    path: '/403',
    name: 'error-403',
    meta: {
        title: '403 - 无权限'
    },
    component: resolve => {
        require(['@/views/common/403.vue'], resolve);
    }
};

// 404
const page404 = {
    path: '/*',
    name: 'error-404',
    meta: {
        title: '404 - 页面不存在'
    },
    component: resolve => {
        require(['@/views/common/404.vue'], resolve);
    }
};

// 前台相关路由
const appRouter = [{
    path: '/',
    name: 'home_index',
    meta: {
        title: '首页'
    },
    redirect: '/home',
    component: resolve => {
        require(['@/views/main.vue'], resolve);
    },
    children: [{
            path: '/home',
            name: 'home',
            meta: {
                title: '我的账户'
            },
            component: resolve => {
                require(['@/views/home/home.vue'], resolve);
            }
        },
        {
            path: '/account-info',
            name: 'account-info',
            meta: {
                title: '实名认证',
                pathWay: '1-1'
            },
            component: resolve => {
                require(['@/views/account-info/account-info.vue'], resolve);
            }
        },
        {
            path: '/card-manage',
            name: 'card-manage',
            meta: {
                title: '银行卡管理',
                pathWay: '1-2'
            },
            component: resolve => {
                require(['@/views/account-info/card-manage.vue'], resolve);
            }
        },
        {
            path: '/change-pwd',
            name: 'change-pwd',
            meta: {
                title: '修改密码',
                pathWay: '1-3'
            },
            component: resolve => {
                require(['@/views/account-info/change-pwd.vue'], resolve);
            }
        },
        {
            path: '/up-account',
            name: 'upaccount',
            meta: {
                title: '账户升级',
                pathWay: '1-4',
                hidden: true
            },
            component: resolve => {
                require(['@/views/account/up-account.vue'], resolve);
            }
        },
        {
            path: '/customer-instructions',
            name: 'customer-instructions',
            meta: {
                title: '客户须知',
                pathWay: '1-5',
                hidden: true
            },
            component: resolve => {
                require(['@/views/account/customer-instructions.vue'], resolve);
            }
        },
        {
            path: '/risk-statement',
            name: 'risk-statement',
            meta: {
                title: '风险声明',
                pathWay: '1-6',
                hidden: true
            },
            component: resolve => {
                require(['@/views/account/risk-statement.vue'], resolve);
            }
        },
        {
            path: '/questionnaire-investigation',
            name: 'questionnaire-investigation',
            meta: {
                title: '问卷调查',
                pathWay: '1-7',
                hidden: true
            },
            component: resolve => {
                require(['@/views/account/questionnaire-investigation.vue'], resolve);
            }
        },
        {
            path: '/upload-data',
            name: 'upload-data',
            meta: {
                title: '上传资料',
                pathWay: '1-8',
                hidden: true
            },
            component: resolve => {
                require(['@/views/account/upload-data.vue'], resolve);
            }
        },
        {
            path: '/state-page',
            name: 'state-page',
            meta: {
                title: '消息',
                pathWay: '1-9',
                hidden: true
            },
            component: resolve => {
                require(['@/views/account/state-page.vue'], resolve);
            }
        },
        {
            path: '/activity',
            name: 'activity',
            meta: {
                title: '新客首充福利',
                pathWay: '1-10',
                hidden: true
            },
            component: resolve => {
                require(['@/views/activity/activity.vue'], resolve);
            }
        },
        {
            path: '/newActivity',
            name: 'newActivity',
            meta: {
                title: '新客首充福利',
                pathWay: '1-11',
                hidden: true
            },
            component: resolve => {
                require(['@/views/activity/newActivity.vue'], resolve);
            }
        },
        {
            path: '/sendActivity',
            name: 'sendActivity',
            meta: {
                title: '充值送赠金活动',
                pathWay: '1-12',
                hidden: true
            },
            component: resolve => {
                require(['@/views/activity/sendActivity.vue'], resolve);
            }
        },
        {
            path: '/activeCenter',
            name: 'activeCenter',
            meta: {
                title: '活动中心',
                pathWay: '1-11',
                hidden: true
            },
            component: resolve => {
                require(['@/views/activity/activeCenter.vue'], resolve);
            }
        },
        {
            path: '/noAgricultural',
            name: 'noAgricultural',
            meta: {
                title: '活动介绍',
                pathWay: '1-12',
                hidden: true
            },
            component: resolve => {
                require(['@/views/activity/noAgricultural.vue'], resolve);
            }
        },
        // 1-13 老带新活动主页 oldbeltnewindex
        {
            path: '/oldbeltnewindex',
            name: 'oldbeltnewindex',
            meta: {
                title: '邀请好友',
                pathWay: '1-13',
                hidden: true
            },
            component: resolve => {
                require(['@/views/activity/oldbeltnewindex.vue'], resolve);
            }
        },
        // 1-14 老带新活动奖励页面
        {
            path: '/rewardtotal',
            name: 'rewardtotal',
            meta: {
                title: '奖励与结算',
                pathWay: '1-14',
                hidden: true
            },
            component: resolve => {
                require(['@/views/activity/rewardtotal.vue'], resolve);
            }
        },
        // 1-15 老带新活动主页 inviteFriend
        {
            path: '/inviteFriend',
            name: 'inviteFriend',
            meta: {
                title: '邀请好友',
                pathWay: '1-13',
                hidden: true
            },
            component: resolve => {
                require(['@/views/activity/inviteFriend.vue'], resolve);
            }
        },
        {
            path: '/funds/passageway',
            name: 'passageway',
            meta: {
                title: '存款',
                pathWay: '2-1',
                type: 'old_passageway'
            },
            component: resolve => {
                require(['@/views/funds/passageway.vue'], resolve);
            }
        },
        {
            path: '/funds/paymenttransfer',
            name: 'paymenttransfer',
            meta: {
                title: '收银台',
                pathWay: '2-1',
                type: 'new_passageway'
            },
            component: resolve => {
                require(['@/views/funds/cashRegister.vue'], resolve);
            }
        }, {
            path: '/funds/cashRegisterAlipay',
            name: 'cashRegisterAlipay',
            meta: {
                title: '收银台',
                type: 'new_passageway'
            },
            component: resolve => {
                require(['@/views/funds/cashRegisterAlipay.vue'], resolve);
            }
        }, {
            path: '/funds/cashRegisterAlipayPid',
            name: 'cashRegisterAlipayPid',
            meta: {
                title: '收银台',
                type: 'new_passageway'
            },
            component: resolve => {
                require(['@/views/funds/cashRegisterAlipayPid.vue'], resolve);
            }
        }, {
            path: '/funds/cashRegisterAlipayBank',
            name: 'cashRegisterAlipayBank',
            meta: {
                title: '收银台',
                type: 'new_passageway'
            },
            component: resolve => {
                require(['@/views/funds/cashRegisterAlipayBank.vue'], resolve);
            }
        }, {
            path: '/funds/cashRegisterBank',
            name: 'cashRegisterBank',
            meta: {
                title: '收银台',
                type: 'new_passageway'
            },
            component: resolve => {
                require(['@/views/funds/cashRegisterBank.vue'], resolve);
            }
        }, {
            path: '/funds/cashRegisterStep',
            name: 'cashRegisterStep',
            meta: {
                title: '收银台',
                type: 'new_passageway'
            },
            component: resolve => {
                require(['@/views/funds/cashRegisterStep.vue'], resolve);
            }
        },
        /* {
          path: '/funds/paymenttransfer',
          name: 'paymenttransfer',
          meta: {
            title: '收银台',
            pathWay: '2-1'
          },
          component: resolve => {
            require(['@/views/funds/paymenttransfer.vue'], resolve);
          }
        }, */
        {
            path: '/funds/online_deposit',
            name: 'onlineDeposit',
            meta: {
                title: '网上存款',
                pathWay: '2-1',
                hidden: true
            },
            component: resolve => {
                require(['@/views/funds/online-deposit.vue'], resolve);
            }
        },
        {
            path: '/funds/rechargeCodePayment',
            name: 'rechargeCodePayment',
            meta: {
                title: '充值码支付',
                pathWay: '2-1',
                hidden: true

            },
            component: resolve => {
                require(['@/views/funds/rechargeCodePayment.vue'], resolve);
            }
        },
        {
            path: '/funds/bankDeposit',
            name: 'bankDeposit',
            meta: {
                title: '银行汇款',
                pathWay: '2-1',
                hidden: true
            },
            component: resolve => {
                require(['@/views/funds/bankDeposit.vue'], resolve);
            }
        },
        {
            path: '/funds/withdraw',
            name: 'withdraw',
            meta: {
                title: '提现',
                pathWay: '2-6'
            },
            component: resolve => {
                require(['@/views/funds/withdraw.vue'], resolve);
            }
        },
        {
            path: '/funds/paymentsEnter',
            name: 'paymentsEnter',
            meta: {
                title: '收支明细',
                pathWay: '2-7'
            },
            component: resolve => {
                require(['@/views/funds/fundsPaymentsEnter.vue'], resolve);
            }
        },
        {
            path: '/funds/transfer-accounts',
            name: 'transferAccounts',
            meta: {
                title: '转账支付',
                pathWay: '2-8',
                hidden: true
            },
            component: resolve => {
                require(['@/views/funds/transfer-accounts.vue'], resolve);
            }
        },
        {
            path: '/funds/alipayTemplates',
            name: 'alipayTemplates',
            meta: {
                title: '支付宝',
                pathWay: '2-9',
                hidden: true
            },
            component: resolve => {
                require(['@/views/funds/alipayTemplates.vue'], resolve);
            }
        },
        {
            path: '/funds/lightningPayment',
            name: 'lightningPayment',
            meta: {
                title: '网上充值',
                pathWay: '2-10',
                hidden: true
            },
            component: resolve => {
                require(['@/views/funds/lightningPayment.vue'], resolve);
            }
        },
        {
            path: '/dollargift',
            name: 'dollargift',
            meta: {
                title: '美元赠金点',
                pathWay: '2-11'
            },
            component: resolve => {
                require(['@/views/dollarGift/index.vue'], resolve);
            }
        },
        {
            path: '/email',
            name: 'email',
            meta: {
                title: '邮件订阅'
            },
            component: resolve => {
                require(['@/views/email/email.vue'], resolve);
            }
        },
        {
            path: '/integration',
            name: 'integration',
            meta: {
                title: '我的积分',
                pathWay: '2-12'
            },
            component: resolve => {
                require(['@/views/integration/index.vue'], resolve);
            }
        }, {
            path: '/integration/detail',
            name: 'integration_detail',
            meta: {
                title: ''
            },
            component: resolve => {
                require(['@/views/integration/detail.vue'], resolve);
            }
        }, {
            path: '/account/upgrade',
            name: 'account_upgrade',
            meta: {
                title: ''
            },
            component: resolve => {
                require(['@/views/accountUpgrade/index.vue'], resolve);
            }
        },

        {
            path: '/trading-info/trading-info',
            name: 'trading-info',
            meta: {
                title: '持仓信息',
                pathWay: '3-1'
            },
            component: resolve => {
                require(['@/views/trading-info/trading-info.vue'], resolve);
            }
        },
        {
            path: '/trading-info/info-history',
            name: 'info-history',
            meta: {
                title: '平仓明细',
                pathWay: '3-2'
            },
            component: resolve => {
                require(['@/views/trading-info/info-history.vue'], resolve);
            }
        },
        {
            path: '/customers/ordinary',
            name: 'ordinary',
            meta: {
                title: '普通客户',
                pathWay: '4-1',
                author: 2
            },
            component: resolve => {
                require(['@/views/customers/ordinary.vue'], resolve);
            }
        },
        {
            path: '/customers/institution',
            name: 'institution',
            meta: {
                title: '机构客户',
                pathWay: '4-2',
                author: 2
            },
            component: resolve => {
                require(['@/views/customers/Institution.vue'], resolve);
            }
        },
        {
            path: '/customers/wallet',
            name: 'wallet',
            meta: {
                title: '电子钱包',
                pathWay: '4-3',
                author: 2
            },
            component: resolve => {
                require(['@/views/customers/wallet.vue'], resolve);
            }
        },
        {
            path: '/customers/rebates-details',
            name: 'rebates-details',
            meta: {
                title: '返佣明细',
                pathWay: '4-4',
                author: 2
            },
            component: resolve => {
                require(['@/views/customers/rebates-details.vue'], resolve);
            }
        },
        {
            path: '/professionalServices/announcement',
            name: 'announcement',
            meta: {
                title: '平台公告',
                pathWay: '5-1',
            },
            component: resolve => {
                require(['@/views/professionalServices/announcement.vue'], resolve);
            }
        },
        // {
        //   path: '/funds/fundsPaymentDetail',
        //   name: 'fundsPaymentDetail',
        //   meta: {
        //     title: '收支明细'
        //   },
        //   component: resolve => {
        //     require(['@/views/funds/fundsPaymentDetail.vue'], resolve);
        //   }
        // },
        {
            path: '/funds/remittance',
            name: 'remittance',
            meta: {
                title: '银行汇款',
            },
            component: resolve => {
                require(['@/views/funds/remittance.vue'], resolve);
            }
        },
        {
            path: '/funds/ebank_pay',
            name: 'ebankPay',
            meta: {
                title: '网银支付'
            },
            component: resolve => {
                require(['@/views/funds/ebank-pay.vue'], resolve);
            }
        },
        {
            path: '/funds/order_payment',
            name: 'orderPayment',
            meta: {
                title: '快捷支付'
            },
            component: resolve => {
                require(['@/views/funds/order-payment.vue'], resolve);
            }
        },
        {
            path: '/funds/add_card',
            name: 'addCard',
            meta: {
                title: '添加银行卡'
            },
            component: resolve => {
                require(['@/views/funds/add-card.vue'], resolve);
            }
        },
        {
            path: '/funds/guideCash',
            name: 'guideCash',
            meta: {
                title: '提现指南'
            },
            component: resolve => {
                require(['@/views/funds/guideCash.vue'], resolve);
            }
        },
        {
            path: '/funds/guideCapitalInjection',
            name: 'guideCapitalInjection',
            meta: {
                title: '注资指南'
            },
            component: resolve => {
                require(['@/views/funds/guideCapitalInjection.vue'], resolve);
            }
        },
        {
            path: '/add-card',
            name: 'add-card',
            meta: {
                title: '添加银行卡'
            },
            component: resolve => {
                require(['@/views/account-info/add-card.vue'], resolve);
            }
        },
        {
            path: '/add-card/card-info',
            name: 'card-info',
            meta: {
                title: '银行资料'
            },
            component: resolve => {
                require(['@/views/account-info/card-info.vue'], resolve);
            }
        },
        {
            path: '/customers/ordinary_details',
            name: 'ordinaryDetails',
            meta: {
                title: '客户明细'
            },
            component: resolve => {
                require(['@/views/customers/ordinary-details.vue'], resolve);
            }
        },
        {
            path: '/customers/institution_details',
            name: 'institutionDetails',
            meta: {
                title: '机构客户明细'
            },
            component: resolve => {
                require(['@/views/customers/institution-details.vue'], resolve);
            }
        },
        {
            path: '/professionalServices/announcementDetail',
            name: 'announcementDetail',
            meta: {
                title: '平台公告详情'
            },
            component: resolve => {
                require(['@/views/professionalServices/announcementDetail.vue'], resolve);
            }
        },
        {
            path: '/rechargeCodePayment',
            name: 'convert',
            meta: {
                title: '充值码支付'
            },
            component: resolve => {
                require(['@/views/funds/rechargeCodePayment.vue'], resolve);
            }
        },
        {
            path: '/callApp',
            name: 'callApp',
            meta: {
                title: ''
            },
            component: resolve => {
                require(['@/views/common/callApp.vue'], resolve);
            }
        },
        {
            path: '/funds/addBaddress',
            name: 'addBaddress',
            meta: {
                title: '收币地址',
                hidden: true
                // pathWay: '2-6'
            },
            component: resolve => {
                require(['@/views/funds/add-baddress'], resolve);
            }
        },
        {
            path: '/funds/applySuccess',
            name: 'applySuccess',
            meta: {
                title: '提现申请',
                hidden: true
                // pathWay: '2-6'
            },
            component: resolve => {
                require(['@/views/funds/applySuccess'], resolve);
            }
        },
        {
            path: '/funds/cancellation',
            name: 'cancellation',
            meta: {
                title: '注销账户',
                hidden: true
                // pathWay: '2-6'
            },
            component: resolve => {
                require(['@/views/funds/cancellation'], resolve);
            }
        },
        {
            path: '/funds/cancellationB',
            name: 'cancellation',
            meta: {
                title: '注销账户',
                hidden: true
                // pathWay: '2-6'
            },
            component: resolve => {
                require(['@/views/funds/cancellationB'], resolve);
            }
        },
        {
            path: '/funds/cancellationC',
            name: 'cancellation',
            meta: {
                title: '注销账户',
                hidden: true
                // pathWay: '2-6'
            },
            component: resolve => {
                require(['@/views/funds/cancellationC'], resolve);
            }
        },
        {
            path: '/funds/cancellationD',
            name: 'cancellation',
            meta: {
                title: '注销账户',
                hidden: true
                // pathWay: '2-6'
            },
            component: resolve => {
                require(['@/views/funds/cancellationD'], resolve);
            }
        },
        {
            path: '/cancelLationXy',
            name: 'cancelLationXy',
            meta: {
                title: '注销账户',
                hidden: true
                // pathWay: '2-6'
            },
            component: resolve => {
                require(['@/views/funds/cancellationXy'], resolve);
            }
        }
    ]
}]

export default {
    router: [
        ...appRouter,
        forgetPwd,
        login,
        realAccount,
        demoAccount,
        agreement,
        page403,
        page404,
    ]
}



// WEBPACK FOOTER //
// ./src/router/router.js